import { PropsWithChildren, SyntheticEvent } from "react"
import { Link } from "react-router-dom"
import { classNames, hasText } from "utils/helpers"
import "./percentage-list-item.less"

type AnchorTarget = undefined | "_self" | "_blank" | "_parent" | "_top"

export default function PercentageListItem(props: {
  title: string
  successRate: number
  routeTo?: string
  href?: string
  onClick?: () => void
  download?: any
  target?: AnchorTarget
}) {
  const { title, successRate, routeTo, href, onClick, target, download } = props
  const isExpandable =
    hasText(routeTo) || hasText(href) || typeof onClick === "function"

  return (
    <li
      className={classNames("percentage-list-item", {
        perfect: successRate >= 100,
      })}
    >
      <PercentageListItemContent
        href={href}
        routeTo={routeTo}
        onClick={onClick}
        target={target}
        download={download}
      >
        <div className="name">{title}</div>
        <div className="addons">
          <div className="success-rate">{Math.round(successRate)}%</div>
          {isExpandable && (
            /*〉*/
            /*＞*/
            /*&gt;*/
            <>≻</>
          )}
        </div>
      </PercentageListItemContent>
      <div className="progress-line" style={{ width: `${successRate}%` }} />
    </li>
  )
}

function PercentageListItemContent(
  props: PropsWithChildren<{
    href?: string
    routeTo?: string
    download?: any
    onClick?: () => void
    target: AnchorTarget
  }>
) {
  const { href, routeTo, onClick, children, target, download } = props

  function handleClick(e: SyntheticEvent) {
    if (onClick) {
      e.preventDefault()
      onClick()
    }
  }

  if (routeTo) {
    return (
      <Link
        to={routeTo}
        className="item-content"
        onClick={handleClick}
        target={target}
        download={download}
      >
        {children}
      </Link>
    )
  } else if (href) {
    return (
      <a
        href={href}
        download={download}
        className="item-content"
        onClick={handleClick}
        target={target}
      >
        {children}
      </a>
    )
  } else {
    return (
      <div
        className={classNames("item-content", {
          "not-expandable": typeof onClick !== "function",
        })}
        onClick={handleClick}
      >
        {children}
      </div>
    )
  }
}
